import { render, staticRenderFns } from "./EmployeeCarouselItem.vue?vue&type=template&id=0531890b&scoped=true"
import script from "./EmployeeCarouselItem.vue?vue&type=script&lang=ts"
export * from "./EmployeeCarouselItem.vue?vue&type=script&lang=ts"
import style0 from "./EmployeeCarouselItem.vue?vue&type=style&index=0&id=0531890b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0531890b",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VIcon,VImg})
